'use client';

import type { HTMLAttributes } from 'react';
import React from 'react';
import classNames from 'classnames';
import { useAppContext } from '$util/AppContext';
import type { AppContextGlobal } from '$util/AppContextGlobal';
import { TopNavigationBar } from '$quantum/organisms/TopNavigationBar';
import { VrmLookupModal } from '$quantum/molecules/VrmLookupModal';
import { CallUsNavButton } from '../../../src/components/molecules/CallUsNavButton';
import { getCmsData } from './cms';

import styles from './index.module.scss';

export interface LandingTopNavigationBarProps extends HTMLAttributes<HTMLDivElement> {}

/**
 * Templates have to be Server Components.
 * Might conditionally load components based on page context.
 *
 * @deprecated use from `src`
 */
export function LandingTopNavigationBar({ className, ...props }: LandingTopNavigationBarProps): JSX.Element {
  const {
    cmsContent: { dictionary },
  } = useAppContext<AppContextGlobal>();

  const { callUsLink } = getCmsData(dictionary);

  return (
    <div className={classNames(LandingTopNavigationBar.displayName, styles.component, className)} {...props}>
      <TopNavigationBar className={styles.sticky}>
        <span className={styles['delimiter-right']} />
        <CallUsNavButton buttonText={callUsLink.text} phoneNumber={callUsLink.url} />
        <VrmLookupModal
          id="LandingTopNavigationBarCta"
          toggleButton={{ size: 'S', className: styles.vrmLookupModal }}
        />
      </TopNavigationBar>
    </div>
  );
}

LandingTopNavigationBar.displayName = 'LandingTopNavigationBar';
